<p-chart type="doughnut" [data]="data" [options]="options"> </p-chart>
